import imageImporterImage from './image.png';
import ImageImporterApp from './App.vue';

export var appConfig = {
	id: 'frontend-image-importer',
	name: 'image-importer',
	version: '1.0.0',
	hash: '',
	type: 'importer',
	title: 'Image Importer',
	author: 'Au-Zone Technologies',
	docs: 'https://doc.edgefirst.ai/latest/datasets/tutorials/import/',
	description: 'Import image files or folders into an existing dataset or create a new destination dataset in Studio.',
	date: new Date().toISOString(),
	runs: 0,
	price: 0,
	image: imageImporterImage,
	component: ImageImporterApp,
	actionLabel: 'Start Import',
	permission: '',
	is_hidden: false,
	user_launchable: true,
};